import { Grid } from '@material-ui/core';
import React from 'react';

import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';

import { FineKinneyPossibilityDefinitionControllerService } from '../../../../api/client';
import { FineKinneyPossibilityDefinitionDto } from '../../../../api/client';
import { updateFineKinneyPossibilityDefinitionUpdate } from '../../../../api/hs/risk-fineKinney';

interface Props {
  open: boolean;
  data: FineKinneyPossibilityDefinitionDto;

  onClose(success: boolean): void;
}

export default function FineKinneyPossibilityDefinitionForm({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<FineKinneyPossibilityDefinitionDto>
      open={open}
      onClose={onClose}
      onSave={FineKinneyPossibilityDefinitionControllerService.saveFineKinneyPossibilityDefinitions}
      onUpdate={updateFineKinneyPossibilityDefinitionUpdate}
      data={data}
      createTitle="Fine-Kinney Olasılık Ekleme"
      updateTitle="Fine-Kinney Olasılık Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="label" label="İsmi" />
      </Grid>
      <Grid item lg={12} md={12}>
        <TextField required name="value" label="Değeri" />
      </Grid>
    </BaseDefinitionForm>
  );
}
